import React, { useState } from "react";
import Logo from "../../img/logo.png";
import { Helmet } from "react-helmet";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../../firebase";
import { ToastContainer, toast } from "react-toastify";
import HeaderAuth from "../../global/header/HeaderAuth";
import { useAuth, useUser } from "../../context/contextAPI";
import { doc, getDoc } from "firebase/firestore";

function Login() {
  const { login } = useAuth();
  const { setUser } = useUser();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const location = useLocation();
  const navigate = useNavigate();

  const validationInfo = () => {
    const errors = {};

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      errors.email = "Votre adresse e-mail invalide";
    }

    if (!password.trim()) {
      errors.password = "Entrer votre mot de passe s'il vous plaît";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const validationErrors = validationInfo();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      const docRef = doc(db, "Users", user.uid);
      const docSnap = await getDoc(docRef);
      const redirectUrl =
        new URLSearchParams(location.search).get("checkout") === "true"
          ? "/panier"
          : "/utilisateur/profil";

      if (docSnap.exists()) {
        const userData = docSnap.data();
        toast.success("Votre compte a été connecté", {
          position: "top-right",
          autoClose: 1500,
          onClose: () => {
            login();
            navigate(redirectUrl);
            setLoading(false);
          },
        });
        setUser(userData);
      } else {
        toast.error("Aucune donnée utilisateur trouvée", {
          position: "top-right",
        });
        setLoading(false);
      }
    } catch (error) {
      toast.error("Aucune donnée utilisateur trouvée", {
        position: "top-right",
      });
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Connexion</title>
      </Helmet>
      <ToastContainer />
      <HeaderAuth />
      <div className="min-h-screen bg-gradient-to-t from-pink-100 via-pink-50 to-pink-100 flex flex-col justify-center pt-24 pb-5 sm:px-6 lg:px-8 px-6">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="flex gap-1 items-center justify-center">
            <img src={Logo} alt="Logo" className="w-10 md:w-12 lg:w-16" />
            <h3 className="text-2xl md:text-3xl lg:text-5xl poppins-bold text-black">
              ECOKAZ
            </h3>
          </div>
          <h2 className="mt-3 text-center text-2xl leading-9 poppins-semibold text-gray-900">
            Connectez-vous à votre compte
          </h2>
          <p className="mt-2 text-center text-sm leading-5 text-black max-w md:text-base">
            Ou
            <Link
              to="/auth/inscription"
              className="hover:underline ho ml-1 font-medium text-blue-600 hover:text-blue-700 focus:outline-none focus:underline transition ease-in-out duration-150"
            >
              Créer un nouveau compte gratuit
            </Link>
          </p>
        </div>

        {/* <PaymentForme /> */}

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form onSubmit={handleSubmit}>
              <div>
                <label
                  for="email"
                  className="block text-sm sm:text-base leading-5  text-gray-700"
                >
                  E-mail
                </label>
                <div className="mt-1 relative rounded-md">
                  <input
                    id="email"
                    placeholder="Entrer votre e-mail"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular  shadow-sm"
                  />
                  {errors.email && email.trim() === "" && (
                    <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                  )}
                </div>
              </div>

              <div className="mt-4">
                <label
                  for="password"
                  className="block text-sm sm:text-base leading-5 text-gray-700"
                >
                  Mot de passe
                </label>
                <div className="mt-1 rounded-md">
                  <input
                    id="password"
                    type="password"
                    placeholder="Entrer votre mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full  shadow-sm rounded-md py-2 md:py-2.5 px-3.5 md:px-4 bg-transparent text-gray-600 border border-gray-300 text-sm transition-all duration-100 outline-none focus:box-border focus:border-pink-600 poppins-regular"
                  />
                  {errors.password && password.trim() === "" && (
                    <p className="text-red-500 text-xs mt-1">
                      {errors.password}
                    </p>
                  )}
                </div>
              </div>

              <div className="mt-6 flex items-center justify-between">
                <div className="text-sm leading-5">
                  <Link
                    to="#"
                    className="text-blue-600 hover:text-blue-700 focus:outline-none focus:underline transition ease-in-out duration-150"
                  >
                    Mot de passe oublié?
                  </Link>
                </div>
              </div>

              <div className="mt-6">
                <span className="block w-full rounded-md shadow-sm">
                  <button
                    type="submit"
                    className={`w-full flex justify-center py-2 px-4 border border-transparent poppins-bold rounded-md text-white focus:outline-none focus:shadow-outline-indigo transition duration-150 ease-in-out ${
                      loading
                        ? "bg-pink-300 cursor-not-allowed"
                        : "bg-black hover:bg-pink-700 cursor-pointer"
                    }`}
                    disabled={loading}
                  >
                    {loading ? (
                      <span className="loading loading-dots loading-md"></span>
                    ) : (
                      <span>Connexion</span>
                    )}
                  </button>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
